import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {useHistory} from '@aboutyou/router';
import {useTrackProductClick} from '@aboutyou/tracking';
import {SHOULD_TRACK_PRODUCT_SELECTION_ADP} from '@aboutyou/ui-components';
import {useEffect} from 'react';

export const useTrackProductSelection = (options: {
  product: Product;
  brand: Brand;
  badges: string[];
}) => {
  const productClick = useTrackProductClick(options.badges, {
    // we need this here because we always want to track the page type and id of the previous item
    trackPreviousPage: true,
  });
  const history = useHistory();
  const {product, brand} = options;

  const track = () => {
    productClick(
      {
        product,
        brand,
      },
      0,
      {
        // This will get passed down straight to the location_id property
        recoType: 'style_picker',
        // we need to pass down an element because otherwise the location_id will be tracked wrong
        elements: [
          {
            id: product.id,
            type: 'product',
          },
        ],
      },
    );
  };

  /**
   * The reason we need to have this effect is because
   * we want to track once the user selected a new color.
   * The problem is that we do not have the information about the product
   * which we need in order to track it. The solution for it is to
   * track it once the user arrives on the new variant.
   */
  useEffect(() => {
    const state = history.location.state as Record<string, string> | undefined;

    // this state is set when the user clicks on a color variant
    if (state?.[SHOULD_TRACK_PRODUCT_SELECTION_ADP]) {
      track();

      const updatedState = {...state};

      delete updatedState[SHOULD_TRACK_PRODUCT_SELECTION_ADP];

      history.replace({
        ...history.location,
        state: updatedState,
      });
    }
  }, [history]);
};
